import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Department, CacheService } from '@mapfre-tech/amap3';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  memoryCache = {
    "getDeparmentsByOS": {
      "data": null,
      "lastReqDate": null
    }
  }

  className = 'DepartmentService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /** 
   * Get all departments
   */
   getAllDepartments(showAll = false, cache = true): Observable<Department[]> | any {
    const params: any = {};
    params.showAll = showAll;
    const cacheKey = "allDepartments"+"_"+showAll.toString();

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<Department[]>(environment.base_URL + "/departments", { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  /**
   * Get departments by organizational structure
   * @param organizationalStructureId 
   * @param cache 
   * @param cacheKey 
   */
  getDepartmentsByOrganizationalStructure(organizationalStructureId: any = null, cache?, cacheKey = "getDeparmentsByOS"): Observable<any[]> {
    let params = {}
    if (organizationalStructureId) {
      cacheKey = cacheKey+"_"+organizationalStructureId.toString()
      params = {
        organizationalStructureId: organizationalStructureId.join(',')
      }
    }
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      const observable = this.http.get<any[]>(environment.base_URL + "/departments", { params: params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  /**
   * Create a department
   * @param department 
   */
  add(department) {

    return this.http.post(environment.base_URL + "/departments", department);
  }

  /**
   * Update a department
   * @param department 
   */
  update(department, id) {

    return this.http.put(environment.base_URL + `/departments/${id}`, department);
  }

  removeById(array) {
    array.forEach(element => {
      delete element.id;
    });
    return array;
  }

  canUseCache(key) {
    const oldDate = _.get(this.memoryCache, `${key}.lastReqDate`);
    let canUse = false;
    if (moment().diff(oldDate, 'minutes') <= 1) {
      canUse = true;
    }
    return canUse;
  }

  updateCacheData(data, key) {
    _.set(this.memoryCache, `${key}.data`, data);
    _.get(this.memoryCache, `${key}._subject`).next(data);
  }

  updateCacheReq(key) {
    const _subject = new Subject<any>();
    const observer = _subject.asObservable();
    _.set(this.memoryCache, key, { observer, _subject, lastReqDate: moment() });
  }
}
